<app-widget-home-core
  [widget]="widget"
  [isStoreView]="isStoreView"
  [subheader]="(date | titlecase) + (local ? ' | ' + local : '')"
  (click)="onClickWidget()"
>

  <app-widget-principal-data
    label="€"
    [data]="widgetData.importe | number: '1.0-0'"
    [showData]="loadedData || isStoreView"
  >

    <div extra-data class="extra-data-wrapper">

      <div
        class="percentage"
        [ngClass]="{'danger': widgetData.porcentaje < 0}"
      >
        <yu-icon
          [name]="widgetData.porcentaje < 0 ? 'arrow-circle-down' : 'arrow-circle-up'"
        ></yu-icon>

        {{ widgetData.porcentaje | number: '1.0-0' }} %
      </div>

    </div>

  </app-widget-principal-data>

</app-widget-home-core>
